import { IconButton, Stack } from '@mui/material';
import { useState } from 'react';
import BaseInputLabel from '../../../../components/custom-inputs/BaseInputLabel';
import CustomChip from '../../../../components/custom-chip/CustomChip';
import { ReactComponent as ArrowDownThinIcon } from '../../../../assets/icons/layout-icons/ArrowDownThinIcon.svg';

interface ChipGroupProps {
  label: string;
  choices: Map<string, string>;
  values: any;
  translation?: {
    t: (key: string, options?: Record<string, unknown>) => string;
    ns?: string;
  };
}

const ChipGroupAccordion = ({ label, choices, values, translation }: ChipGroupProps) => {
  const [open, setOpen] = useState(true);

  const getTranslatedChoiceLabel = (value: string) =>
    translation ? translation.t(value, translation.ns ? { ns: translation.ns } : undefined) : value;

  return (
    <Stack flex={1}>
      <Stack direction="row" justifyContent="space-between">
        <BaseInputLabel text={label} color="primaryDark.900" />
        <IconButton onClick={() => setOpen(!open)}>
          <ArrowDownThinIcon
            width={12}
            height={8}
            style={{
              transform: open ? 'rotate(180deg)' : 'rotate(0)',
              transition: 'all 0.2s',
              color: 'red !important',
            }}
          />
        </IconButton>
      </Stack>
      <Stack
        direction="row"
        gap={1}
        flexWrap="wrap"
        overflow="hidden"
        sx={{
          maxHeight: open ? 'max-content' : '0px',
        }}
      >
        {values?.map((item: any) => (
          <CustomChip label={getTranslatedChoiceLabel(choices.get(item) ?? '')} />
        ))}
      </Stack>
    </Stack>
  );
};

export default ChipGroupAccordion;
